var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearbyicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51997 9.06224C0.965556 8.52031 0.965556 7.64168 1.51997 7.09975L7.54313 1.2123C8.09754 0.670375 8.99643 0.670375 9.55085 1.2123L19.5894 11.0247C20.1439 11.5666 20.1439 12.4453 19.5894 12.9872L13.5663 18.8747C13.0119 19.4166 12.113 19.4166 11.5586 18.8747L1.51997 9.06224ZM6.53927 6.11851C5.43044 7.20236 5.43044 8.95963 6.53927 10.0435L10.5547 13.9684C11.6635 15.0523 13.4613 15.0523 14.5701 13.9684C15.679 12.8846 15.679 11.1273 14.5701 10.0435L10.5547 6.11851C9.44587 5.03466 7.6481 5.03466 6.53927 6.11851Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5786 23.7808C16.0242 23.2389 16.0242 22.3603 16.5786 21.8183L22.6017 15.9309C23.1561 15.389 24.055 15.389 24.6094 15.9309L34.648 25.7433C35.2025 26.2852 35.2025 27.1639 34.648 27.7058L28.6249 33.5933C28.0705 34.1352 27.1716 34.1352 26.6172 33.5933L16.5786 23.7808ZM21.5979 20.8371C20.489 21.921 20.489 23.6782 21.5979 24.7621L25.6133 28.687C26.7221 29.7709 28.5199 29.7709 29.6287 28.687C30.7376 27.6032 30.7376 25.8459 29.6287 24.7621L25.6133 20.8371C24.5045 19.7533 22.7067 19.7533 21.5979 20.8371Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.061 11.5154C12.6154 10.9735 13.5143 10.9735 14.0687 11.5154L24.1073 21.3278C24.6617 21.8697 24.6617 22.7484 24.1073 23.2903C23.5529 23.8322 22.654 23.8322 22.0996 23.2903L12.061 13.4779C11.5066 12.936 11.5066 12.0573 12.061 11.5154Z",
    fill: "#9EC6E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearbyicon);
export default __webpack_public_path__ + "static/media/nearbyicon.be1b9e1a3e9abbf53bb966bd1230befe.svg";
export { ForwardRef as ReactComponent };